// extracted by mini-css-extract-plugin
export default {"tableRowActions":"Wh02F9i7s5VkUBwTNMqu"};